
function Mayors() {
  return (
    <div className="container">
      <h1>Mayors</h1>
    </div>
  );
}
export default Mayors;
